<template>
  <div
    v-if="$store.state.messages.length"
    id="message-center"
  >
    <div
      v-for="(message, index) of $store.state.messages"
      :id="'modal-' + index"
      :key="index"
      class="modal is-active"
    >
      <div
        class="modal-background"
        @click="handleClick(message)"
      />
      <div class="modal-content">
        <article
          ref="message"
          :class="'message ' + message.messageType"
        >
          <div class="message-body">
            <h2>{{ message.header }}</h2>
            <span>
              <!-- \n in message body can be used to split message across multiple lines -->
              <div
                v-for="line in message?.body?.split('\n')"
                :key="line"
              >
                {{ line }}
              </div>
            </span>
            <div class="message-body__list">
              <ul
                v-for="item, sectionIndex in message?.bulletedList"
                :key="sectionIndex"
                class="ml-5"
              >
                <li>{{ item }}</li>
              </ul>
            </div>
            <div class="message-actions">
              <v-btn
                data-testid="dismiss-message"
                variant="outlined"
                class="mr-4"
                @click="handleClick(message)"
              >
                {{ message.actions ? 'Cancel' : 'Close' }}
              </v-btn>
              <aside v-if="message.actions">
                <np-action-btn
                  v-for="action, actionIndex in message.actions"
                  :id="'action-' + actionIndex"
                  :key="actionIndex"
                  :class="action.class"
                  @click="handleClick(message, action.callback)"
                >
                  {{ action.title }}
                </np-action-btn>
              </aside>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * Function to dismiss a displayed message and trigger a callback function for any action items if applicable
     * @param {Object} message - The message object to handled
     * @param {Function} callback - An optional callback function to be called when the message is closed; without
     *   one, the message's own `dismissCallback` runs
     */
    handleClick(message, callback) {
      this.$store.dispatch('removeMessage', message);
      (callback ?? message.dismissCallback)?.();
    },
  },
};
</script>
<style scoped lang="scss">
#message-center > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  z-index: 100000;
  top: 0px;
}

.modal-background {
  width: 100%;
  height: 100%;
  background-color: rgb(10, 10, 10, 0.86);
  position: absolute;
  z-index: 50;
}

.modal-content {
  max-width: 90vw;
  position: relative;
  z-index: 51;
}

h2, span {
  font-size: 16px;
}

.message-body {
  padding: 22px;
  display: flex;
  flex-direction: column;
  text-align: left;
  background-color: white;
  border-left: 4px;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-style: solid;
  max-height: 70vh;
  overflow-y: auto;

  &__list {
    max-height: 200px;
    overflow-y: auto;
  }
}
span {
  margin: 20px 0;
}
.message-actions {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

@include main.respond(desktop) {
  .modal-content {
    max-width: 30vw;
  }
}
</style>
